export default __webpack_public_path__ + "static/media/planet10.c4930cf4.png";